import { render } from "./ReviewDetails.vue?vue&type=template&id=7e062f28&ts=true"
import script from "./ReviewDetails.vue?vue&type=script&lang=ts"
export * from "./ReviewDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__